export const duration = {
  scrollbar: '100ms'
} as const;

export const easing = {
  default: 'ease-out'
} as const;
